import script from "./ScheduleItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScheduleItem.vue?vue&type=script&lang=ts&setup=true"

import "./ScheduleItem.vue?vue&type=style&index=0&id=0e51bdd7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e51bdd7"]])

export default __exports__